import React from 'react';
import {Card} from "../../components/Card";
import AuthenticationService from "../../platform/authentication/AuthenticationService";
import {createInternationalizationPrefixer} from "../../platform/i18n/i18n";
import {AuthLanguageSwitcher} from "./AuthLanguageSwitcher";

const t = createInternationalizationPrefixer("NoAccessLandingPage");

export function NoAccessLandingPage() {
    return <div>
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <AuthLanguageSwitcher/>
                        <Card>
                            <LandingHeader/>
                            <LandingBody/>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer footer-alt text-dark text-center">
            {(new Date().getFullYear())} &copy; Wentech
        </footer>
    </div>;
}

function LandingHeader() {
    return <div className="text-center">
        <div className="clearfix text-center pt-20 pb-20">
            <img src="/img/wentech_logo.svg" width="60%" alt="logo"/>
            <div className="text-muted mt-3">
                <h3>Optisel 2</h3>
            </div>
        </div>
    </div>;
}

function LandingBody() {
    return <div className="text-center">
        <h4>{t("Twoje konto jest aktywne, ale nie ma jeszcze przydzielonych uprawnień.")}</h4>
        <p className="mt-3">{t("Skontaktuj się z administratorem, aby uzyskać dostęp.")}</p>
        <button className="btn btn-link mt-3" onClick={AuthenticationService.deAuthenticate}>
            {t("Wyloguj")}
        </button>
    </div>;
}
